<template>
  <div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <img src="../assets/image/Frame.png" alt="" srcset="" />
          <div class="noText">没有找到您的健康档案</div>
          <div class="gobutton" @click="GotoBtn">现在就去填写</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    GotoBtn() {
      this.$router.push("/recordsHealth");
    },
  },
};
</script>

<style  lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 253px;
  height: 320px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 10px;
  text-align: center;
  img {
    margin-top: 40px;
  }
  .noText {
    font-size: 12px;
    font-weight: 400;
    color: #cccccc;
  }
  .gobutton {
    width: 162px;
    height: 40px;
    margin: 0 auto;
    background: #07c160;
    border-radius: 4px 4px 4px 4px;
    font-size: 17px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    margin-top: 40px;
  }
}
</style>